// The API origin, in a module of its own (moved out of client.ts in Phase 3,
// 2026-09-30) so src/i18n/apiFetch.ts can read it without a circular import
// with client.ts, which sends every request through apiFetch. client.ts
// re-exports apiUrl, so `import { apiUrl } from './client'` keeps working.
export const DEFAULT_API_BASE = 'https://mtg-assistant.up.railway.app'

/**
 * Absolute URL for an API path. The single place the API origin is joined to
 * a path, used by every request helper and by the client-built links that
 * point at API redirect routes (Card Kingdom buy links), so there is no
 * second origin to drift. Trailing slashes on the configured base are
 * stripped and the path always gets exactly one leading slash, so a
 * `VITE_API_URL` of `http://localhost:8000/` cannot produce `//stores`.
 * Read per call so a test can stub the env without reloading the module.
 */
export function apiUrl(path: string): string {
  const base = (import.meta.env.VITE_API_URL || DEFAULT_API_BASE).replace(/\/+$/, '')
  return `${base}/${path.replace(/^\/+/, '')}`
}
